import { Locale } from '__generated__/EditorJsField_data.graphql';
import { EditorJsFieldType } from './useEditorJsField';

type BlockInput = {
  locale: Locale;
  data: string;
};

type TextBlockInput = {
  blocks: BlockInput[];
};

export function makeEditorJsInput(field: EditorJsFieldType) {
  const input: TextBlockInput = {
    blocks: [],
  };

  for (let locale in field) {
    if (field[locale]) {
      input.blocks.push({
        locale: locale as Locale,
        data: JSON.stringify(field[locale]),
      });
    }
  }

  return input;
}
